export enum MessageIntent {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning'
}

export interface MessageProps {
  uid: string | number;
  message: string;
  intent?: MessageIntent;
  duration?: number;
  onClose?: (message: MessageProps) => void;
}

export interface MessagesProps {
  messages: MessageProps[];
  onClose: (message: MessageProps) => void;
}



// WEBPACK FOOTER //
// ./src/components/Messages/types.ts